export default "__VITE_ASSET__fff63289__"